import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`, // Assumes token is stored in localStorage
    },
  };
}

export const getTotalRevenueReport = async (groupBy) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/revenue-report/revenue_annual_report/?group_by=${groupBy}`,
      getHeaders()
    );
    return response.data; // Return the data field from the API response
  } catch (error) {
    throw new Error(
      error.response?.data?.error || "Failed to fetch revenue report"
    );
  }
};
